import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"pl-5 mt-6"},[_c(VCardTitle,[_vm._v(" Comparativo de número de cotas vendidas "+_vm._s(_vm.region)+" ")]),_c(VRow,{staticClass:"mt-6"},[_c(VCol,[_c('chartjs-component-line-chart',{key:_vm.data,attrs:{"height":100,"data":_vm.lineChart.data}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }